import { queryClient } from "@/api/utils";
import { Center, Spinner } from "@givenwell/components";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRootRoute, HeadContent, Outlet, Scripts } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <HeadContent />
      <Suspense
        fallback={
          <Center css={{ w: "100%", h: 64 }}>
            <Spinner />
          </Center>
        }
      >
        <Outlet />
      </Suspense>
      <Suspense fallback={null}>
        <Toaster />
      </Suspense>
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <Devtools />
        </Suspense>
      )}
      <Scripts />
    </QueryClientProvider>
  );
}

const Toaster = lazy(async () => {
  const { Toaster } = await import("@givenwell/components");
  return { default: Toaster };
});

const Devtools = lazy(() => import("./devtools"));
